import { Bars } from "react-loader-spinner";

const SpinLoader = () => {
	return (
		<div
			style={{
				height: "80vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Bars type="Bars" color="#e41f26" height={50} width={50} visible />
		</div>
	);
};

export default SpinLoader;
